import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    coachType: null,
    coachInfo: null,
    clubOrHighschool: null,
    snackbar: {
      open: false,
      status: null
    },
    isLoggedIn: false
  },
  mutations: {
    setCoachType(state, coachType) {
      state.coachType = coachType;
    },
    setCoachInfo(state, coachInfo) {
      state.coachInfo = coachInfo
    },
    setClubOrHighschool(state, clubOrHighschool) {
      state.clubOrHighschool = clubOrHighschool;
    },
    openSnackbar(state, status) {
      state.snackbar = {
        open: true,
        status
      };
    },
    closeSnackbar(state) {
      state.snackbar.open = false;
    },
    clearState(state) {
      state.coachType = null;
      state.coachInfo = null;
      state.clubOrHighschool = null;
    },
    setAuthState(state, authState) {
      state.isLoggedIn = authState
    }
  },
  actions: {
    submit({ }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "https://us-central1-prod-imlca.cloudfunctions.net/addAthletesSubmission",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "IMLCA"
              }
            }
          ).then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          })
      })

    }
  },
  modules: {
  }
})
